import React, { useEffect, useState } from "react";
import "./styles.less";
import { Button } from "../../components/Button";
import { blogAxios } from "../../utils/blogAxios";
import { dateFormat } from "../../utils";
import { useTranslation } from "react-i18next";
import { Title } from "../../components/NewTitle";

export const MainNews = () => {
  const [articles, setArticles] = useState([]);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    blogAxios.get("/website-news").then(({ data }) => {
      setArticles(
        data.map((item) => ({
          ...item.article,
          content: item.article.content.replace(/<.*?>/g, ""),
          createdAt: dateFormat(item.article.createdAt),
        }))
      );
    });
  }, []);

  return (
    articles.length &&
    i18n.language === "zh-CN" && (
      <div className="home-news">
        <div className="inner">
          <Title title={t("page.news.title")}></Title>
          <div className="content">
            {articles.map((item, index) => {
              return (
                <a
                  href={`/blog/detail/${item.id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  key={index}
                  className="item"
                >
                  <div className="item-image">
                    <img src={item.cover} alt={item.title} />
                  </div>
                  <div className="item-content-text">
                    <div title={item.title} className="item-title">
                      {item.title}
                    </div>
                    <div title={item.content} className="item-text">
                      {item.content}
                    </div>
                    {/* <div className="item-date">
                      <span>{dateFormat(item.publishedAt)}</span>
                      <span className="item-arrow">
                        <i
                          className="icon authing-icon authing-arrow-down-line"
                          style={{
                            transform: "rotate(90deg)",
                            display: "inline-block",
                          }}
                        ></i>
                      </span>
                    </div> */}
                  </div>
                </a>
              );
            })}
            <div className="learn-more" onClick={() => window.open("/blog")}>
              <span className="learn-more-warp">
                <span className="learn-more-text">
                  {t("common.button.see-more")}
                </span>
                <i
                  className="icon authing-icon authing-arrow-down-line arrow"
                  style={{
                    transform: "rotate(90deg)",
                    display: "inline-block",
                  }}
                ></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    )
  );
};
